<template>
  <div class="specialPricing-base">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "specialPricingBase",
};
</script>
